<!-- eslint-disable vue/no-parsing-error -->
<template>
    <div>

        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <input id="search" v-model="filter.search" type="text" class="form-control" placeholder="Search...">
                </div>
            </div>
            <div class="col-md-6" />
            <div class="col-md-2">
                <b-button id="create" v-b-modal.form-modal variant="primary" class="btn-block" @click="cleanUpForm()">
                    Create
                </b-button>
            </div>
        </div>

        <b-card-code no-body>
            <div class="table-responsive-sm">
                <table class="table b-table table-fixed">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Role</th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="isLoading">
                            <td colspan="5" class="text-center">
                                <b-spinner label="Loading..." variant="primary" />
                            </td>
                        </tr>
                        <template v-if="!isLoading">
                            <tr v-for="item, index in users" :key="index">
                                <td>{{ item.name || '-' }}</td>
                                <td>{{ item.email || '-' }}</td>
                                <td>{{ item.role || '-' }}</td>
                                <td class="text-right">
                                    <div class="btn-group" role="group" aria-label="Basic example"
                                        v-if="userData._id != item._id">
                                        <b-button id="edit" variant="info" class="btn-sm" style="margin-left: 2px;"
                                            data-toggle="tooltip" data-placement="top" title="Edit"
                                            @click="editItem(item)">
                                            <feather-icon icon="EditIcon" />
                                        </b-button>

                                        <b-button id="search" variant="danger" class="btn-sm" style="margin-left: 2px;"
                                            data-toggle="tooltip" data-placement="top" title="Delete"
                                            @click="deleteItem(item._id)">
                                            <feather-icon icon="Trash2Icon" />
                                        </b-button>

                                    </div>
                                </td>
                            </tr>
                            <tr v-if="totalItems == 0">
                                <td colspan="5" class="text-center">
                                    Data is empty.
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>

                <div class="row mt-1 mx-0">
                    <div class="col-6 pl-2">
                        <small>Showing {{ Math.min(perPage * currentPage, totalItems) }} to {{ totalItems || 0 }} from
                            {{ totalRows || 0
                            }}
                        </small>
                    </div>
                    <div class="col-6 pr-2">
                        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="right"
                            size="sm" class="my-0" />
                        <!-- <pagination :data="result" :limit="4" align="right" @pagination-change-page="getData" /> -->
                    </div>
                </div>
            </div>
        </b-card-code>

        <!-- Add/Edit Modal -->
        <b-modal id="form-modal" size="lg" :title="editId != null ? 'Edit User' : 'Add User'" no-close-on-backdrop>

            <div class="form-group">
                <label for="name">Name: <span class="text-danger">*</span></label>
                <b-form-input id="name" v-model="formPayload.name" type="text" class="form-control"
                    :class="validations.hasOwnProperty('name') && validations.name.length > 0 ? 'is-invalid' : ''"
                    placeholder="Name" />
                <small v-if="validations.hasOwnProperty('name') && validations.name.length > 0" class="text-danger">
                    {{ validations.name.join(', ') }}
                </small>
            </div>

            <div class="form-group">
                <label for="email">Email:</label>
                <b-form-input id="email" v-model="formPayload.email" type="text" class="form-control"
                    :class="validations.hasOwnProperty('email') && validations.email.length > 0 ? 'is-invalid' : ''"
                    placeholder="email" rows="3" />
                <small v-if="validations.hasOwnProperty('email') && validations.email.length > 0" class="text-danger">
                    {{ validations.email.join(', ') }}
                </small>
            </div>

            <div class="form-group">
                <label for="password">Password:</label>
                <b-input-group class="input-group-merge">
                    <b-form-input id="password" v-model="formPayload.password" :type="passwordFieldType"
                        class="form-control-merge"
                        :class="validations.hasOwnProperty('password') && validations.password.length > 0 ? 'is-invalid' : ''"
                        placeholder="password" />
                    <b-input-group-append is-text>
                        <feather-icon class="cursor-pointer" :icon="passwordToggleIcon"
                            @click="togglePasswordVisibility" />
                    </b-input-group-append>
                </b-input-group>

                <small v-if="validations.hasOwnProperty('password') && validations.password.length > 0"
                    class="text-danger">
                    {{ validations.password.join(', ') }}
                </small>
            </div>

            <div class="form-group">
                <label for="role">Role:</label>
                <b-form-select id="role" v-model="formPayload.role" type="text" class="form-control"
                    :class="validations.hasOwnProperty('role') && validations.role.length > 0 ? 'is-invalid' : ''">
                    <b-form-select-option :value="option.value" v-for="option, index in options" :key="index">{{
                        option.text }}</b-form-select-option>
                </b-form-select>
                <small v-if="validations.hasOwnProperty('role') && validations.role.length > 0" class="text-danger">
                    {{ validations.role.join(', ') }}
                </small>
            </div>

            <div class="form-group" v-if="userData.role == 'admin'">
                <label for="partner">Partner:</label>
                <v-select id="partner" v-model="formPayload.partner" :options="optionsPartner"
                    :reduce="item => item.uuid" label="name" placeholder="Type to search Partner..."
                    @search="onSearchPartner">
                    <template slot="no-options">
                        Type here to search partner...
                    </template>
                </v-select>
            </div>

            <template #modal-footer="{}">
                <div v-if="isLoading" class="mb-1">
                    <b-spinner class="mb-2" variant="primary" /><br>
                </div>
                <b-button id="save-item" v-if="editId == null" variant="success" :disabled="isLoading"
                    @click="createItem()">
                    Save Item
                </b-button>
                <b-button id="save-item" v-else variant="success" :disabled="isLoading" @click="updateItem()">
                    Save Item
                </b-button>
            </template>
        </b-modal>
        <!-- Add/Edit Modal -->

    </div>
</template>

<script>
import _ from 'lodash'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
    BCard, BCardText, BButton, BDropdown, BDropdownItem, BSpinner,
    BFormGroup, BTabs, BTab, BNavItem, BPagination, BFormInput, BFormFile, BRow, BCol, BForm, BFormTextarea, BFormSelect, BFormSelectOption, BInputGroupAppend, BInputGroup,
} from 'bootstrap-vue'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'

import { successNotification, errorNotification } from '@/auth/utils'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'

export default {
    title() {
        return 'User Management'
    },
    components: {
        BFormGroup,
        BCard,
        BButton,
        BCardText,
        BCardCode,
        BDropdown,
        BDropdownItem,
        BTabs,
        BTab,
        BNavItem,
        BSpinner,
        BPagination,
        BFormInput,
        BFormFile,
        BRow,
        BCol,
        BForm,
        BFormTextarea,
        BFormSelect,
        vSelect,
        BFormSelectOption,
        BInputGroupAppend,
        BInputGroup,
    },
    directives: {
        Ripple,
    },
    mixins: [heightTransition, togglePasswordVisibility],
    watch: {
        filter: {
            handler: _.debounce(function () {
                this.getData()
            }, 300),
            deep: true,
        },
        currentPage: {
            handler: _.debounce(function (value) {
                this.getData(value);
            }, 300),
            deep: true,
        },
    },
    setup() {
        return { successNotification, errorNotification }
    },
    data() {
        const userData = JSON.parse(localStorage.getItem('userData'))
        return {
            userData,
            // Pagination
            currentPage: 1,
            totalRows: 0,
            perPage: 10,
            itemCount: 0,
            totalItems: 0,
            pageOptions: [3, 5, 10],

            options: [
                { value: null, text: 'Please select an option' },
                { value: 'owner', text: 'Owner' },
                { value: 'editor', text: 'Editor' },
                { value: 'contributor', text: 'Contributor' },
            ],

            result: Object,
            users: [],
            isLoading: false,
            formPayload: {
                name: '',
                email: '',
                password: '',
                role: null,
                partner: null,
            },
            editId: null,
            filter: {
                search: '',
            },
            validations: {},
            optionsPartner: []
        }
    },
    computed: {
        passwordToggleIcon() {
            return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
        },
        filteredOptionsRole() {
            // If user is 'owner', filter out the 'owner' option
            if (this.userData?.role === 'owner') {
                return this.options.filter(option => option.value !== 'owner');
            }
            return this.options;
        },
    },
    mounted() {
        this.getData()
        this.getPartner()
    },
    created() {
    },
    destroyed() {
    },
    methods: {
        onSearchPartner(search, loading) {
            if (search.length) {
                loading(true)
                this.searchPartner(loading, search, this)
            }
        },
        searchPartner: _.debounce((loading, search, vm) => {
            vm.$http.get(`admin/partners?&search=${encodeURI(search)}`)
                .then(response => {
                    vm.optionsPartner = response.data.data.items.map(obj => ({
                        uuid: obj._id,
                        name: obj.name,
                    }))
                })
                .catch(error => {
                    console.error(error)
                })
            loading(false)
        }, 300),
        getPartner() {
            if (this.userData?.role === 'admin') {
                this.$http.get('/admin/partners', {
                }).then((result) => {
                    this.optionsPartner = result.data.data.items.map(obj => ({
                        uuid: obj._id,
                        name: obj.name,
                    }))
                }).catch((err) => {

                });
            }
        },
        cleanUpForm() {
            this.editId = null
            this.formPayload = {
                name: '',
                email: '',
                password: '',
                role: null,
                partner: null,
            }
        },
        getData(page = 1) {
            this.isLoading = true
            this.currentPage = page
            const queryParams = this.filter
            queryParams.page = this.currentPage

            this.$http.get('/admin/users/pagination', {
                params: queryParams,
            })
                .then(response => {
                    const data = response.data.data;
                    this.users = data.items
                    this.result = data;
                    this.itemCount = data.meta.item_count;
                    this.totalItems = data.meta.total_items;
                    this.currentPage = data.meta.current_page;
                    this.totalRows = data.meta.total_items;
                    this.isLoading = false;
                })
        },
        createItem() {
            const qs = require('qs')
            const form = qs.stringify(this.formPayload)

            this.$http.post('/admin/users/create', form, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            })
                .then(response => {
                    this.$bvModal.hide('form-modal')
                    this.getData(this.currentPage)
                    successNotification(this, 'Success', 'User successfully created')
                    this.cleanUpForm()
                })
                .catch(error => {
                    const validations = error.response.data.meta.validations
                    const messages = error.response.data.meta.messages
                    // this.validations = validations
                    if (validations) {
                        for (const key in validations) {
                            if (validations.hasOwnProperty(key)) {
                                errorNotification(this, 'Oops!', key + ' ' + validations[key].join(', '))
                            }
                        }
                    }
                    if (messages) {
                        errorNotification(this, 'Oops!', messages)
                    }
                })
        },
        updateItem() {
            const qs = require('qs')
            const form = qs.stringify(this.formPayload)

            this.$http.patch(`/admin/users/update/${this.editId}`, form, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            })
                .then(response => {
                    this.$bvModal.hide('form-modal')
                    this.getData(this.currentPage)
                    successNotification(this, 'Success', 'User successfully updated!')
                    this.cleanUpForm()
                })
                .catch(error => {
                    const validations = error.response.data.meta.validations
                    const messages = error.response.data.meta.messages
                    // this.validations = validations
                    if (validations) {
                        for (const key in validations) {
                            if (validations.hasOwnProperty(key)) {
                                errorNotification(this, 'Oops!', key + ' ' + validations[key].join(', '))
                            }
                        }
                    }
                    if (messages) {
                        errorNotification(this, 'Oops!', messages)
                    }
                })
        },
        preparePayload() {
            const form = new FormData()
            // eslint-disable-next-line no-restricted-syntax
            for (const key in this.formPayload) {
                if (this.formPayload.hasOwnProperty(key) && this.formPayload[key] != null && this.formPayload[key] != '') {
                    // Handle if this.formPayload[key] is array
                    form.append(key, this.formPayload[key])
                }
            }

            return form
        },
        editItem(item) {
            this.$http.get(`admin/users/detail/${item._id}`).then((result) => {
                const { name, email, role, partner } = result.data.data
                this.formPayload = {
                    name: name,
                    email: email,
                    role: role,
                    partner: partner._id,
                }
                this.optionsPartner = []
                if (partner !== null) {
                    this.optionsPartner.push({
                        uuid: partner._id,
                        name: partner.name
                    })
                }
                this.editId = item._id
                this.$bvModal.show('form-modal')
            }).catch((err) => {

            });
        },
        deleteItem(id) {
            this.$swal({
                title: 'Are you sure?',
                text: 'Are you sure to delete this user?',
                icon: 'warning',
                showCancelButton: true,
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1',
                },
                buttonsStyling: false,
            }).then(result => {
                if (result.value) {
                    this.$http.delete(`admin/users/delete/${id}`)
                        .then(response => {
                            this.getData(this.currentPage)
                            this.$swal({
                                icon: 'success',
                                title: 'Success!',
                                text: 'User successfully deleted',
                                customClass: {
                                    confirmButton: 'btn btn-success',
                                },
                            })
                        })
                        .catch(error => {
                            const validations = error.response.data.meta.validations
                            const messages = error.response.data.meta.messages
                            // this.validations = validations
                            if (validations) {
                                for (const key in validations) {
                                    if (validations.hasOwnProperty(key)) {
                                        errorNotification(this, 'Oops!', key + ' ' + validations[key].join(', '))
                                    }
                                }
                            }
                            if (messages) {
                                errorNotification(this, 'Oops!', messages)
                            }
                        })
                }
            })
        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.repeater-form {
    overflow: hidden;
    transition: .35s height;
}
</style>
